import React, { useState, useEffect } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import { Col, Row, Card, CardBody, CardHeader, Alert } from "reactstrap"
import {
  Fn_AddEditData,
  Fn_DisplayData,
  Fn_FillListData,
} from "../../store/Functions"
import { useDispatch } from "react-redux"
import { API_WEB_URLS, getGlobalOptions } from "../../constants/constAPI"
import { useLocation, useNavigate } from "react-router-dom"

// No validation schema - all fields optional
const validationSchema = {}

function UpdateGlobalOptions() {
  const API_URL_SAVE = "UpdateGlobalOptions/0/token"
  const [logoFile, setLogoFile] = useState(null)
  const [logoPreview, setLogoPreview] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const API_URL = API_WEB_URLS.MASTER + "/0/token/UpdateGlobalOptions"
  const API_URL1 = API_WEB_URLS.MASTER + "/0/token/UnitMaster"
  const API_URL2 = API_WEB_URLS.MASTER + "/0/token/FinancialYearMaster"

  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/UpdateGlobalOptions/Id"

  const [state, setState] = useState({
    id: 0,
    formData: {
      Note1: "",
      Note2: "",
      Note3: "",
      Note4: "",
      Note5: "",
      Note6: "",
      Name: "",
      Username: "",
      Password: "",
      F_UnitMaster: "",
      F_FinancialYearMaster: "",
      GstNo: "",
      PanNo: "",
      Mobile: "",
      Address: "",
      City: "",
      State: "",
      Logo: "",
    },
    UnitArray: [],
    FinancialYearArray: [],
    isLoading: false,
    submitSuccess: false,
  })

  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "UnitArray", API_URL1 + "/Id/0")
    Fn_FillListData(dispatch, setState, "FinancialYearArray", API_URL2 + "/Id/0")
  }, [])

  // When existing logo loads, set preview
  useEffect(() => {
    if (state.formData.Logo) {
      setLogoPreview(API_WEB_URLS.IMAGEURL + state.formData.Logo)
    }
  }, [state.formData.Logo])

  useEffect(() => {
    const Id = 1

    if (Id > 0) {
      setState(prevState => ({ ...prevState, id: Id }))
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT)
    } else {
      navigate("/UpdateGlobalOptions")
    }
  }, [dispatch, location.state, navigate])

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setState(prevState => ({ ...prevState, isLoading: true }))
    
    const obj = JSON.parse(localStorage.getItem("authUser"))
    let formData = new FormData()

    formData.append("Name", values.Name)
    formData.append("Username", values.Username || "")
    formData.append("Password", values.Password || "")
    formData.append("Note1", values.Note1)
    formData.append("Note2", values.Note2)
    formData.append("Note3", values.Note3)
    formData.append("Note4", values.Note4)
    formData.append("Note5", values.Note5)
    formData.append("Note6", values.Note6)
    formData.append("F_UnitMaster", values.F_UnitMaster)
    formData.append("F_FinancialYearMaster", values.F_FinancialYearMaster)
    formData.append("GstNo", values.GstNo || "")
    formData.append("PanNo", values.PanNo || "")
    formData.append("Mobile", values.Mobile || "")
    formData.append("Address", values.Address || "")
    formData.append("City", values.City || "")
    formData.append("State", values.State || "")
    formData.append("UserId", obj.uid)
    if (logoFile) {
      formData.append("Logo", logoFile)
    }

    try {
      await Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVE,
        true,
        "memberid",
        navigate,
        "/UpdateGlobalOptions"
      )
      
      setState(prevState => ({ 
        ...prevState, 
        isLoading: false, 
        submitSuccess: true 
      }))

      // Update localStorage GlobalOptions so ContractPrint / reports use latest firm data
      try {
        const current = getGlobalOptions()
        const merged = current && current.length > 0 ? { ...current[0] } : {}
        merged.Name = values.Name
        merged.Username = values.Username || ""
        merged.Password = values.Password || ""
        merged.Note1 = values.Note1
        merged.Note2 = values.Note2
        merged.Note3 = values.Note3
        merged.Note4 = values.Note4
        merged.Note5 = values.Note5
        merged.Note6 = values.Note6
        merged.F_UnitMaster = values.F_UnitMaster
        merged.F_FinancialYearMaster = values.F_FinancialYearMaster
        merged.GstNo = values.GstNo || ""
        merged.PanNo = values.PanNo || ""
        merged.Mobile = values.Mobile || ""
        merged.Address = values.Address || ""
        merged.City = values.City || ""
        merged.State = values.State || ""
        if (logoFile) merged.Logo = logoFile.name
        localStorage.setItem("GlobalOptions", JSON.stringify([merged]))
      } catch (e) { console.warn("Update GlobalOptions in localStorage failed", e) }
      
      // Hide success message after 3 seconds
      setTimeout(() => {
        setState(prevState => ({ ...prevState, submitSuccess: false }))
      }, 3000)
      
    } catch (error) {
      setState(prevState => ({ ...prevState, isLoading: false }))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row className="justify-content-center">
          <Col lg="10" xl="10">
            <Card className="shadow-sm border-0">
              <CardHeader className="bg-primary text-white">
                <div className="d-flex align-items-center">
                  <i className="fas fa-cog me-3 fs-4"></i>
                  <div>
                    <h4 className="mb-0 fw-semibold">Firm Master</h4>
                
                  </div>
                </div>
              </CardHeader>
              
              <CardBody className="p-4">
                {state.submitSuccess && (
                  <Alert color="success" className="mb-4">
                    <i className="fas fa-check-circle me-2"></i>
                    Global options updated successfully!
                  </Alert>
                )}

                <Formik
                  initialValues={{
                    Name: state.formData.Name || "",
                    Username: state.formData.Username || "",
                    Password: state.formData.Password || "",
                    Note1: state.formData.Note1 || "",
                    Note2: state.formData.Note2 || "",
                    Note3: state.formData.Note3 || "",
                    Note4: state.formData.Note4 || "",
                    Note5: state.formData.Note5 || "",
                    Note6: state.formData.Note6 || "",
                    F_UnitMaster: state.formData.F_UnitMaster || "",
                    F_FinancialYearMaster: state.formData.F_FinancialYearMaster || "",
                    GstNo: state.formData.GstNo || "",
                    PanNo: state.formData.PanNo || "",
                    Mobile: state.formData.Mobile || "",
                    Address: state.formData.Address || "",
                    City: state.formData.City || "",
                    State: state.formData.State || "",
                  }}
                  enableReinitialize={true}
                  validationSchema={undefined}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting }) => (
                    <Form>
                      {/* Name Field */}
                   <Row>
                    <Col md="6">
                    <div className="mb-4">
                        <label htmlFor="Name" className="form-label fw-semibold text-dark">
                          <i className="fas fa-tag me-2 text-primary"></i>
                        Company Name
                        </label>
                        <Field
                          className="form-control form-control-lg"
                          type="text"
                          name="Name"
                          placeholder="Enter company name"
                        />
                      </div>
                    </Col>
                    <Col md="3">
                     
                            <label htmlFor="F_FinancialYearMaster" className="form-label fw-semibold text-dark">
                              <i className="fas fa-calendar-alt me-2 text-primary"></i>
                               Financial Year
                            </label>
                            <Field as="select" 
                              className="form-select" 
                              name="F_FinancialYearMaster"
                            >
                              <option value="">Select a financial year</option>
                              {state.FinancialYearArray.map(type => (
                                <option key={type.Id} value={type.Id}>
                                  {type.Name}
                                </option>
                              ))}
                            </Field>
                          </Col>

                          <Col md="3">
                            <label htmlFor="F_UnitMaster" className="form-label fw-semibold text-dark">
                              <i className="fas fa-ruler me-2 text-primary"></i>
                              Unit
                            </label>
                            <Field as="select" 
                              className="form-select" 
                              name="F_UnitMaster"
                            >
                              <option value="">Select a unit</option>
                              {state.UnitArray.map(type => (
                                <option key={type.Id} value={type.Id}>
                                  {type.Name}
                                </option>
                              ))}
                            </Field>
                          </Col>
                   </Row>

                      {/* Username and Password */}
                      <Row className="mb-3">
                        <Col md="6">
                          <label htmlFor="Username" className="form-label fw-semibold text-dark">
                            <i className="fas fa-user me-2 text-primary"></i>
                            Username
                          </label>
                          <Field
                            className="form-control"
                            type="text"
                            name="Username"
                            placeholder="Enter username"
                          />
                        </Col>
                        <Col md="6">
                          <label htmlFor="Password" className="form-label fw-semibold text-dark">
                            <i className="fas fa-lock me-2 text-primary"></i>
                            Password
                          </label>
                          <div className="input-group">
                            <Field
                              className="form-control"
                              type={showPassword ? "text" : "password"}
                              name="Password"
                              placeholder="Enter password"
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setShowPassword(p => !p)}
                              tabIndex={-1}
                            >
                              <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                            </button>
                          </div>
                        </Col>
                      </Row>

                      {/* Address, City, State */}
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <label htmlFor="Address" className="form-label fw-semibold text-dark">
                              <i className="fas fa-map-marker-alt me-2 text-primary"></i>
                              Address
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Address"
                              placeholder="Enter address"
                            />
                            <ErrorMessage name="Address" component="div" className="invalid-feedback" />
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="mb-3">
                            <label htmlFor="City" className="form-label fw-semibold text-dark">City</label>
                            <Field className="form-control" type="text" name="City" placeholder="City" />
                            <ErrorMessage name="City" component="div" className="invalid-feedback" />
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="mb-3">
                            <label htmlFor="State" className="form-label fw-semibold text-dark">State</label>
                            <Field className="form-control" type="text" name="State" placeholder="State" />
                            <ErrorMessage name="State" component="div" className="invalid-feedback" />
                          </div>
                        </Col>
                      </Row>

                      {/* GstNo, PanNo, Mobile */}
                      <Row>
                        <Col md="4">
                          <div className="mb-3">
                            <label htmlFor="GstNo" className="form-label fw-semibold text-dark">GST No</label>
                            <Field className="form-control" type="text" name="GstNo" placeholder="GSTIN" />
                            <ErrorMessage name="GstNo" component="div" className="invalid-feedback" />
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="mb-3">
                            <label htmlFor="PanNo" className="form-label fw-semibold text-dark">PAN No</label>
                            <Field className="form-control" type="text" name="PanNo" placeholder="PAN" />
                            <ErrorMessage name="PanNo" component="div" className="invalid-feedback" />
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="mb-3">
                            <label htmlFor="Mobile" className="form-label fw-semibold text-dark">Mobile</label>
                            <Field className="form-control" type="text" name="Mobile" placeholder="Mobile" />
                            <ErrorMessage name="Mobile" component="div" className="invalid-feedback" />
                          </div>
                        </Col>
                      </Row>

                      {/* Logo Section */}
                      <Row className="mb-4">
                        <Col md="12">
                          <label className="form-label fw-semibold text-dark">
                            <i className="fas fa-image me-2 text-primary"></i>
                            Company Logo
                          </label>
                          <div className="d-flex align-items-center gap-3 flex-wrap">
                            {logoPreview && (
                              <img
                                src={logoPreview}
                                alt="Company Logo"
                                style={{ height: 70, maxWidth: 200, objectFit: "contain", border: "1px solid #dee2e6", borderRadius: 6, background: "#f8f9fa", padding: 4 }}
                              />
                            )}
                            <input
                              type="file"
                              accept="image/*"
                              className="form-control"
                              style={{ maxWidth: 320 }}
                              onChange={e => {
                                const file = e.target.files[0]
                                if (file) {
                                  setLogoFile(file)
                                  setLogoPreview(URL.createObjectURL(file))
                                }
                              }}
                            />
                          </div>
                          {state.formData.Logo && !logoFile && (
                            <small className="text-muted mt-1 d-block">Current: {state.formData.Logo}</small>
                          )}
                        </Col>
                      </Row>

                      {/* Notes Section */}
                      <div className="mb-4">
                        <h6 className="text-muted mb-3">
                          <i className="fas fa-sticky-note me-2"></i>
                          Additional Notes
                        </h6>
                        
                        {/* Note1 and Note2 in single row */}
                        <Row className="mb-3">
                          <Col md="6">
                            <label htmlFor="Note1" className="form-label fw-medium">
                              Note 1
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Note1"
                              placeholder="Enter note 1 (optional)"
                            />
                          </Col>
                          <Col md="6">
                            <label htmlFor="Note2" className="form-label fw-medium">
                              Note 2
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Note2"
                              placeholder="Enter note 2 (optional)"
                            />
                          </Col>
                        </Row>

                        {/* Note3 and Note4 in single row */}
                        <Row className="mb-3">
                          <Col md="6">
                            <label htmlFor="Note3" className="form-label fw-medium">
                              Note 3
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Note3"
                              placeholder="Enter note 3 (optional)"
                            />
                          </Col>
                          <Col md="6">
                            <label htmlFor="Note4" className="form-label fw-medium">
                              Note 4
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Note4"
                              placeholder="Enter note 4 (optional)"
                            />
                          </Col>
                        </Row>

                        {/* Note5 and Unit Master in single row */}
                        <Row className="mb-4">
                          <Col md="6">
                            <label htmlFor="Note5" className="form-label fw-medium">
                              Note 5
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Note5"
                              placeholder="Enter note 5 (optional)"
                            />
                          </Col>
                          <Col md="6">
                            <label htmlFor="Note6" className="form-label fw-medium">
                              Note 6
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Note6"
                              placeholder="Enter note 6 (optional)"
                            />
                          </Col>
                        
                        </Row>

                        
                      </div>

                      {/* Action Buttons */}
                      <div className="d-flex gap-3 pt-3">
                        <button 
                          type="submit" 
                          className="btn btn-primary btn-lg px-4 flex-fill"
                          disabled={isSubmitting || state.isLoading}
                        >
                          {isSubmitting || state.isLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Updating...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-save me-2"></i>
                              Update Configuration
                            </>
                          )}
                        </button>
                        
                        <button 
                          type="button" 
                          className="btn btn-outline-secondary btn-lg px-4"
                          onClick={() => navigate("/dashboard")}
                        >
                          <i className="fas fa-arrow-left me-2"></i>
                          Cancel
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default UpdateGlobalOptions
